import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { CircularProgress, CloseIcon, CheckmarkCircleFillIcon, XMarkCircleFillIcon, Tooltip } from "@flat-ui";
import { Grid } from "@mui-wrapper";
import { useAppDispatch } from "@store/store-helper";
import { removeOneManually } from "@store/table/table-slice";
import { getSvgColoredIconCss } from "@utils/ui-utils";
import { PALETTE_VARS } from "@styles/palette-vars";

/** Size of the status icon in pixels */
const ICON_SIZE_PX = 20;
/** Shows appropriate icon based on the fetching status */
export function ListStatusIcon(t0) {
  const $ = _c(13);
  const {
    item
  } = t0;
  const dispatch = useAppDispatch();
  let statusIcon = null;
  bb0: switch (item.status) {
    case "idle":
      {
        let t1;
        if ($[0] !== dispatch || $[1] !== item.id) {
          t1 = <Tooltip component="div" title="Remove from this list"><SphereIconButton component={CloseIcon} onClick={() => dispatch(removeOneManually(item.id))} iconSize={`${ICON_SIZE_PX}px`} /></Tooltip>;
          $[0] = dispatch;
          $[1] = item.id;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        statusIcon = t1;
        break bb0;
      }
    case "in-queue":
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CircularProgress size={`${ICON_SIZE_PX}px`} sx={{
            color: PALETTE_VARS.primary.main,
            margin: "8px"
          }} />;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        statusIcon = t1;
        break bb0;
      }
    case "updating":
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CircularProgress size={`${ICON_SIZE_PX}px`} sx={{
            margin: "8px"
          }} />;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        statusIcon = t1;
        break bb0;
      }
    case "success":
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CheckmarkCircleFillIcon sx={{
            ...getSvgColoredIconCss(PALETTE_VARS.success.main),
            height: `${ICON_SIZE_PX}px`,
            width: `${ICON_SIZE_PX}px`,
            margin: "8px"
          }} />;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        statusIcon = t1;
        break bb0;
      }
    case "error":
      {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <XMarkCircleFillIcon sx={{
            ...getSvgColoredIconCss(PALETTE_VARS.error.main),
            height: `${ICON_SIZE_PX}px`,
            width: `${ICON_SIZE_PX}px`,
            margin: "8px"
          }} />;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        statusIcon = t1;
      }
  }
  let t1;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center"
    };
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== item.message) {
    t2 = item.message && <Tooltip component="div" title={<var>{item.message}</var>} sx={{
      color: "primary.main",
      fontSize: "12px",
      mr: "20px",
      cursor: "pointer"
    }}>View info</Tooltip>;
    $[8] = item.message;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== statusIcon || $[11] !== t2) {
    t3 = <Grid container={true} sx={t1}>{t2}{statusIcon}</Grid>;
    $[10] = statusIcon;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}